import { Record } from 'react-admin';
import { Db } from './types';

const names = ['管理番号', '設計番号', '工事番号'];

export const generateClientWorkIdTypes = (db: Db): Record[] => {
    return Array.from(Array(names.length).keys()).map(i => {
        const createdAt = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000);
        return {
            id: i + 1,
            name: names[i],
            createdAt: createdAt,
            updatedAt: createdAt,
        };
    });
};
